export default __webpack_public_path__ + "static/169-26984f27098ff6deb1806a483ebf6bc4.jpg";